/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskLanguageKeyRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskLanguageKeyRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import {
	languageTranslationsResource,
	outgoingEmailStateModelResource,
} from '@jira/router-resources__translations/src/outgoingEmailStateModelResource.tsx';
import ServiceDeskLanguageTranslations, {
	LazyProjectSettingsServiceDeskLanguageTranslations,
} from './ui/service-desk-language-translations/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const projectSettingsServicedeskLanguageKeyRouteEntry: Route = createEntry(
	projectSettingsServicedeskLanguageKeyRoute,
	() => ({
		group: 'project-settings-servicedesk',
		ufoName: 'service-management.translations',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskLanguageTranslations,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getServiceDeskSettingsResources(),
			getConsolidationStateResource(),
			languageTranslationsResource,
			outgoingEmailStateModelResource,
		],

		meta: {
			reporting: {
				id: APP_NAMES.LANGUAGE_SETTINGS,
				packageName: toPackageName(APP_NAMES.LANGUAGE_SETTINGS),
				teamName: 'jsm-banana',
			},
		},

		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskLanguageTranslations],
		perfMetricKey: 'jsm-language-translations',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
